<div class="modal-body dxf-import-body">

  <!-- File picker -->
  <div class="import-file-section">
    <div class="import-file-input-wrapper">
      <!-- Hidden native input; styled label acts as the click trigger -->
      <input type="file" name="dxfFile" class="import-file-input-hidden" id="dxfGroupFile" required
        (change)="handleDxfImport($event)"
        multiple accept=".dxf, image/vnd.dxf">
      <label class="import-file-btn" for="dxfGroupFile">
        <i class="bi bi-file-earmark-code"></i> Choose DXF Files
      </label>
      <span class="import-selected-filename" id="dxfFileNameDisplay">No files chosen</span>
    </div>
    <span class="import-file-hint"><i class="bi bi-info-circle"></i> Multiple files supported &mdash; accepted format: .dxf</span>
  </div>

  <!-- Selected files preview table -->
  <div class="import-table-scroll-wrapper">
    <table class="import-preview-table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">File Name</th>
        </tr>
      </thead>

      <tbody *ngIf="dxfFiles && dxfFiles.length; else emptyState">
        <tr *ngFor="let file of dxfFiles; index as i">
          <td class="row-index">{{ i + 1 }}</td>
          <td><i class="bi bi-file-earmark-code file-icon"></i> {{ file.name }}</td>
        </tr>
      </tbody>

      <ng-template #emptyState>
        <tbody>
          <tr>
            <td colspan="2" class="import-empty-state">
              <i class="bi bi-cloud-upload"></i>
              <span>No files selected &mdash; choose one or more DXF files to upload</span>
            </td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>

</div>

<div class="modal-footer import-modal-footer">
  <div class="import-error-message" *ngIf="displayError">
    <i class="bi bi-exclamation-triangle-fill"></i> {{errorMessage}}
  </div>
  <button type="button" class="import-btn-upload" (click)="uploadDxfFiles()">
    <i class="bi bi-cloud-upload"></i> Upload
  </button>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="square-loader" [fullScreen]="false">
  <p class="spinner-loading-text">Uploading...</p>
</ngx-spinner>